/* istanbul ignore file */
export { default as InviteLinkBuilder } from "./wrappers/invite-link-builder.js";
export { default as SignupForm } from "./wrappers/signup-form.js";
export { default as GuestSignupForm } from "./wrappers/guest-signup-form.js";

import { setEnv as setDynamicImportEnv } from "./util/dynamic-env.js";

// Store this function on the window so devs can access it
if (typeof window !== "undefined") {
  window.__ns_account_components_setDynamicImportEnv = setDynamicImportEnv;
}
export { setDynamicImportEnv };
